module.exports = __webpack_public_path__ + "assets/img/driver-btn-42d39299.png";